import dayjs from 'dayjs'
import customFormat from 'dayjs/plugin/customParseFormat'
import relativeTime from 'dayjs/plugin/relativeTime'

import './api'
import './localisation'
// Any IE polyfills etc
import '@hoxtonmix/setup/polyfill-common'

dayjs.extend(customFormat)
dayjs.extend(relativeTime)
